<template>
  <div style="flex:1">
    <el-image
      v-if="
        data.questionType == 1 ||
          data.questionType == 2 ||
          data.questionType == 7
      "
      :src="data.url"
      fit="contain"
      :preview-src-list="[data.url]"
      :style="{ height: size + 'px' }"
    >
    </el-image>
    <video
      :src="data.url"
      controls
      v-else-if="data.questionType == 3"
      :style="{ height: size + 'px' }"
    ></video>
    <audio :src="data.url" controls v-else-if="data.questionType == 4"></audio>
    <el-tooltip
      effect="dark"
      :content="fileText"
      placement="top"
      v-else
      :disabled="!isTable"
      popper-class="file-text"
    >
      <div :class="['detail-btn', isTable ? 'is-table' : '']">
        {{ fileText }}
      </div>
    </el-tooltip>
    <!-- <el-tooltip placement="top" v-else popper-class="detail-popover">
      <div slot="content">{{ data.url || JSON.parse(data.problem) }}</div>
      <div class="detail-btn">{{ data.url || JSON.parse(data.problem) }}</div>
    </el-tooltip> -->
  </div>
</template>

<script>
export default {
  name: "FileDetail",
  props: {
    data: {
      type: Object,
      required: true
    },
    size: {
      type: String || Number,
      required: false,
      default: 200
    },
    isTable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    fileText() {
      return this.data.url || this.data.problem;
    }
  }
};
</script>
<style>
.detail-popover {
  max-width: 600px;
  font-size: 14px;
}
.detail-btn {
  width: 100%;
}
.is-table {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}
.file-text {
  max-width: 600px;
  white-space: all;
}
</style>



// WEBPACK FOOTER //
// src/components/FileDetail.vue